module.exports = __webpack_public_path__ + "static/media/21_l_lamp_23.23_0.2cec829a.png";